module.exports = __webpack_public_path__ + "fromGroomToMother-we-b.0358ffe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToMother-we-b.jpg
// module id = OiM7
// module chunks = 0